import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export function AiTab() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/ai/settings').then(r => setSettings(r.data)).catch(() => {});
  }, []);

  const update = (field, value) => setSettings(prev => ({ ...prev, [field]: value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      const { setting_id, ...data } = settings;
      await api.put('/ai/settings', data);
      toast.success('Configuration IA sauvegardee');
    } catch {
      toast.error('Erreur');
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return <div className="text-center py-8 text-muted-foreground">Chargement...</div>;

  return (
    <div className="space-y-4">
      <Card className="border">
        <CardHeader>
          <CardTitle className="text-lg" style={{ fontFamily: 'Outfit, sans-serif' }}>IA - Harmonisation des photos</CardTitle>
          <CardDescription>Configurez l'outil IA pour ameliorer et harmoniser les photos d'identite</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center gap-2">
            <Switch checked={settings.enabled || false} onCheckedChange={v => update('enabled', v)} data-testid="ai-enabled-switch" />
            <Label>Activer l'harmonisation IA des photos</Label>
          </div>
          <div className="space-y-2">
            <Label>Fournisseur par defaut</Label>
            <Select value={settings.provider || 'openai'} onValueChange={v => update('provider', v)}>
              <SelectTrigger data-testid="ai-provider-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="openai">OpenAI (GPT Image 1)</SelectItem>
                <SelectItem value="gemini">Gemini (Nano Banana)</SelectItem>
              </SelectContent>
            </Select>
            <p className="text-xs text-muted-foreground">Les citoyens pourront choisir le fournisseur lors du traitement. Ce choix definit la valeur par defaut.</p>
          </div>
          <div className="space-y-2">
            <Label>Cle API</Label>
            <Input type="password" value={settings.api_key || ''} onChange={e => update('api_key', e.target.value)} placeholder="sk-..." data-testid="ai-api-key" />
          </div>
        </CardContent>
      </Card>

      <Button className="bg-[#007FFF] hover:bg-[#0066CC]" onClick={handleSave} disabled={saving} data-testid="save-ai-btn">
        {saving ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Save className="w-4 h-4 mr-2" />}
        Sauvegarder
      </Button>
    </div>
  );
}
